module.exports = __webpack_public_path__ + "src/assets/media/notification.e468230b.mp3";